import angular from 'angular';

var module = angular.module('app.settings', []);

export default module;